var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 624.875,
    height: 498.875,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3,
    in: "SourceAlpha",
    result: "result0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 6.6,
    result: "result1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.9,
    in: "result1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.3 0",
    result: "result91"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "result91",
    in: "result0",
    operator: "out",
    result: "result2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7,
    result: "result4"
  }), /*#__PURE__*/React.createElement("feDiffuseLighting", {
    surfaceScale: 10,
    result: "result92"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    azimuth: 225,
    elevation: 45
  })), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    mode: "multiply",
    result: "result93"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "result3"
  }), /*#__PURE__*/React.createElement("feSpecularLighting", {
    in: "result4",
    surfaceScale: 5,
    specularExponent: 17.9,
    result: "result94"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    azimuth: 225,
    elevation: 45
  })), /*#__PURE__*/React.createElement("feComposite", {
    in2: "result3",
    operator: "atop"
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-11.063 -12.063)",
    style: {
      lineHeight: "125%"
    },
    x: 322.67,
    y: 132.938,
    fontSize: 40,
    fontWeight: 400,
    letterSpacing: 0,
    wordSpacing: 0,
    fill: "none",
    stroke: "#0000b3",
    strokeWidth: 3,
    fontFamily: "Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 322.67,
    y: 132.938,
    style: {
      textAlign: "center",
      InkscapeFontSpecification: "Arial Bold"
    },
    fontSize: 100,
    fontWeight: 700,
    textAnchor: "middle",
    fontFamily: "Arial"
  }, "What our"), /*#__PURE__*/React.createElement("tspan", {
    x: 322.67,
    y: 257.938,
    style: {
      textAlign: "center",
      InkscapeFontSpecification: "Arial Bold"
    },
    fontSize: 100,
    fontWeight: 700,
    textAnchor: "middle",
    fontFamily: "Arial"
  }, "clients"), /*#__PURE__*/React.createElement("tspan", {
    x: 322.67,
    y: 382.938,
    style: {
      textAlign: "center",
      InkscapeFontSpecification: "Arial Bold"
    },
    fontSize: 100,
    fontWeight: 700,
    textAnchor: "middle",
    fontFamily: "Arial"
  }, "said")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.1fa82c458a17235ef71dd5f88f606e9b.svg";
export { ForwardRef as ReactComponent };